export function getRoleHome(role) {
    switch (role) {
        case 'superadmin':
            return '/superadmin/respondentsRegistry';
        case 'admin':
            return '/admin/reports/registry';
        case 'respondent':
            return '/participant/outcome/required';
        case 'integration':
            return '/integration';
        case 'monitor':
            return '/monitor/forms';
        default:
            return '/';
    }
}
